import "./ranking_agents.page.scss";
import { FC } from "react";
import LayoutComponent from "../../../layouts/layoutComponent/layout.component";
import TableSatisfactionComponent from "../../dashboard/components/tableSatisfaction/table_satisfaction.component";
import KeyWordLocalization from "../../../utils/KeyWordLocalization";
import ButtonComponent from "../../../components/button/button.component";
import { ErrorMessage } from "@hookform/error-message";
import Validators from "../../../utils/Validators";
import LoadingComponent from "../../../components/LoadingComponent/loading.component";
import PaginatorComponent from "../../../components/paginator/PaginatorComponent";
import useRankingAgentsPageViewModel from "./ranking_agents.page.view_model";
import AutoCompleteWithCheckComponent from "../../../components/autocompleteWithCheck/AutoCompleteWithCheckComponent";

const RankingAgentsPage: FC<{}> = () => {
  const {
    i18n,
    register,
    handleSubmit,
    watch,
    errors,
    data,
    colors,
    _onSubmit,
    _handleChangePage,
    _handleChangeSortBy,
    _handleSeeAgentDetails,
    _handleDownloadAgentData,
    onSearchAiAgent,
    handleChangeAiAgent,
    _handleChangeSortField,
    formInfo,
    onChangeForm,
    itemsPerPage,
    setItemsPerPage,
    currentPage,
    setCurrentPage,
    getValues,
    _searchRankingData,
  } = useRankingAgentsPageViewModel();

  const {
    reset,
  } = formInfo;

  return (
    <div className="ranking_agents_page">
      <LayoutComponent title={i18n(KeyWordLocalization.RankingAgentsPageTitle)}>
        <div className="container">
          <form onSubmit={handleSubmit(_onSubmit)}>
            <div className="row mb-3">
              <div
                className={`form-group col-md-7 mb-2 ${errors[KeyWordLocalization.RankingAgentsPageSearchByName] &&
                  "error error_group"
                  }`}
              >
                <label className="form-label">
                  {i18n(KeyWordLocalization.RankingAgentsPageSearchByName)}
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={i18n(
                    KeyWordLocalization.RankingAgentsPageSearchByName
                  )}
                  {...register(
                    KeyWordLocalization.RankingAgentsPageSearchByName,
                    Validators({})
                  )}
                />
                <ErrorMessage
                  as={"aside"}
                  errors={errors}
                  name={KeyWordLocalization.RankingAgentsPageSearchByName}
                />
              </div>
              <div className="form-group pt-2 col-md-5 mb-2">
                <AutoCompleteWithCheckComponent
                  multiple={false}
                  keyName={KeyWordLocalization.RankingAgentsPageFormForm}
                  label={i18n(KeyWordLocalization.RankingAgentsPageFormForm)}
                  formInfo={formInfo}
                  onSearch={onSearchAiAgent}
                  onChange={handleChangeAiAgent}
                />
              </div>
              <div
                className={`form-group col-md-5 mb-2 ${errors[KeyWordLocalization.RankingAgentsPageStartDate]
                  ? "error"
                  : ""
                  }`}
              >
                <label className="form-label">
                  {i18n(KeyWordLocalization.RankingAgentsPageStartDate)}
                </label>
                <input
                  type="date"
                  className="form-control"
                  max={new Date().toISOString().split("T")[0]}
                  {...register(
                    KeyWordLocalization.RankingAgentsPageStartDate,
                    Validators({
                      onChange: onChangeForm,
                    })
                  )}
                />
                <ErrorMessage
                  as="aside"
                  errors={errors}
                  name={KeyWordLocalization.RankingAgentsPageStartDate}
                />
              </div>
              <div
                className={`form-group col-md-5 mb-2 ${errors[KeyWordLocalization.RankingAgentsPageEndDate]
                  ? "error"
                  : ""
                  }`}
              >
                <label className="form-label">
                  {i18n(KeyWordLocalization.RankingAgentsPageEndDate)}
                </label>
                <input
                  type="date"
                  className="form-control"
                  max={new Date().toISOString().split("T")[0]}
                  {...register(
                    KeyWordLocalization.RankingAgentsPageEndDate,
                    Validators({
                      greaterOrEqualThan: watch(
                        KeyWordLocalization.RankingAgentsPageStartDate
                      ),
                      onChange: onChangeForm,
                    })
                  )}
                />
                <ErrorMessage
                  as="aside"
                  errors={errors}
                  name={KeyWordLocalization.RankingAgentsPageEndDate}
                />
              </div>
              <div className="col-md-2 mb-2 d-flex align-items-end">
                <ButtonComponent
                  design="primaryOutline"
                  className="w-100 justify-content-center"
                  type="submit"
                  icon={
                    <span className="material-symbols-outlined">search</span>
                  }
                />
              <ButtonComponent
                    design="dangerOutline"
                    className="w-100 justify-content-center"
                    onClick={() => {
                      reset({
                        [KeyWordLocalization.RankingAgentsPageSearchByName]: [],
                        [KeyWordLocalization.RankingAgentsPageFormForm]: [],
                        [KeyWordLocalization.RankingAgentsPageStartDate]: "",
                        [KeyWordLocalization.RankingAgentsPageEndDate]: "",
                      });
                      setCurrentPage(1);
                      handleSubmit(_onSubmit)();
                    }}
                    icon={<span className="material-symbols-outlined">refresh</span>}
                  />
              </div>
            </div>
          </form>
          <div className="row">
            <div className="col-12">
              {data === undefined && <LoadingComponent />}
              {data === null && (
                <div>{i18n(KeyWordLocalization.RankingAgentsPageNoData)}</div>
              )}
              {data && (
                <>
                  <div className="card">
                    <div className="card-body">
                      <TableSatisfactionComponent
                        showHeader={false}
                        title={""}
                        data={data.data}
                        colors={colors}
                        openAgentDetails={_handleSeeAgentDetails}
                        downladAgentResume={_handleDownloadAgentData}

                        sortField={watch(KeyWordLocalization.RankingAgentsPageSortField)}
                        sortOrder={watch(KeyWordLocalization.RankingAgentsPageSortBy)}
                        handleChangeSort={_handleChangeSortField}
                      />
                    </div>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div>
                      <label className="me-2">
                        {i18n(KeyWordLocalization.ItemsPerPageLabel) || "Items por página"}:
                      </label>
                      <select
                        className="form-select d-inline-block w-auto"
                        value={itemsPerPage}
                        onChange={(e) => {
                          const newItemsPerPage = Number(e.target.value);
                          setItemsPerPage(newItemsPerPage);
                          setCurrentPage(1);
                        
                          const formData = getValues();
                          const params = {
                            query: formData[KeyWordLocalization.RankingAgentsPageSearchByName],
                            initDate: formData[KeyWordLocalization.RankingAgentsPageStartDate]
                              ? new Date(formData[KeyWordLocalization.RankingAgentsPageStartDate])
                              : undefined,
                            endDate: formData[KeyWordLocalization.RankingAgentsPageEndDate]
                              ? new Date(formData[KeyWordLocalization.RankingAgentsPageEndDate])
                              : undefined,
                            page: 1,
                            itemsPerPage: newItemsPerPage,
                            sortBy: formData[KeyWordLocalization.RankingAgentsPageSortBy],
                            sortField: formData[KeyWordLocalization.RankingAgentsPageSortField],
                            aiAgentId: formData[KeyWordLocalization.RankingAgentsPageAiAgentId] || undefined,
                          };
                        
                          formInfo.setValue(KeyWordLocalization.RankingAgentsPagePage, 1);
                          _searchRankingData(params);
                        }}
                      >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                      </select>
                    </div>
                  </div>



                  <div className="paginator mt-3">
                    {data.pages > 1 && (
                      <PaginatorComponent
                        resultData={data}
                        onChangePage={_handleChangePage}
                      />
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </LayoutComponent>
    </div>
  );
};

export default RankingAgentsPage;
